export function titlePage(data = {}) {
  data.title = data.title || "IRIS";
  document.title = data.title;
}
